import React from 'react'
import classNames from 'classnames';

import InputAdornment from "@material-ui/core/InputAdornment";
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip'
import { FaInfoCircle } from 'react-icons/fa';

const DomainOption = props => (
    <div className="form-input-container">
        <div>
            <b>Domain Inputs: </b><FaInfoCircle data-tip data-for="domain-info"/>
            <ReactTooltip id='domain-info' place="right" type="light" effect="solid">
                <div>MMIF is recommended when the grid is greater than 46 km.  It is recommended that PM2.5 and Ozone are modeled with a grid larger than 30 km.</div>
                <div>Non-MMIF grids, terrain is processed for the extent listed in this section.</div>
                <div>MMIF grids, terrain is processed at a subset ~ 10 km around the facility and included in the SCICHEM run with a spacing of ~100 m.</div>
                <div>An output grid of 100 m spacing is used for receptor locations for non-MMIF grids, where it is then 0.02-0.05 degres depending on the domain size.</div>
            </ReactTooltip>

        </div>
        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
            data-tip data-for="dEW">
            <InputLabel shrink>Size (east-west)</InputLabel>
            <Input
                style={{width: "100px", paddingLeft: '20px'}}
                inputProps={{ min: "5", max: "1600", step: "1"}}
                type="number"
                label=""
                name="dEW"
                value={props.dEW}
                onChange={props.handleInputChange}
                placeholder='10'
                endAdornment={<InputAdornment position="end">km</InputAdornment>}
            />
        </FormControl>
        <ReactTooltip id='dEW' place="bottom" type="light" effect="solid">
            <div>
                A domain larger than 46 km, MMIF should be used.
            </div>
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
            data-tip data-for="dNS">
            <InputLabel shrink>Size (north-south)</InputLabel>
            <Input
                style={{width: "100px"}}
                inputProps={{ min: "5", max: "1600", step: "1" }}
                type="number"
                label=""
                name="dNS"
                value={props.dNS}
                onChange={props.handleInputChange}
                placeholder='10'
                endAdornment={<InputAdornment position="end">km</InputAdornment>}
            />
        </FormControl>
        <ReactTooltip id='dNS' place="bottom" type="light" effect="solid">
            <div>
                A domain larger than 46 km, MMIF should be used.
            </div>
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
            data-tip data-for="spacing">
            <InputLabel shrink>Model Spacing</InputLabel>
            <Input
                style={{width: "100px"}}
                inputProps={{ min: "100", max: "5000", step: "50" }}
                type="number"
                label=""
                name="spacing"
                value={props.spacing}
                onChange={props.handleInputChange}
                placeholder='100'
                endAdornment={<InputAdornment position="end">m</InputAdornment>}
            />
        </FormControl>
        <ReactTooltip id='spacing' place="bottom" type="light" effect="solid">
            <div>
                Resolution for the model run in meters. (Used in TERSCI, Ignored if using MMIF)
            </div>
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
            data-tip data-for="dHeight">
            <InputLabel shrink>Size in the Vertical</InputLabel>
            <Input
                style={{width: "100px"}}
                inputProps={{ min: "2000", max: "5000", step: "100" }}
                type="number"
                label=""
                name="dHeight"
                value={props.dHeight}
                onChange={props.handleInputChange}
                placeholder='2500'
                endAdornment={<InputAdornment position="end">m</InputAdornment>}
            />
        </FormControl>
        <ReactTooltip id='dHeight' place="bottom" type="light" effect="solid">
            <div>
                Vertical height of the modeling domain.
            </div>
        </ReactTooltip>
    </div>
)
export default DomainOption;
